import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getUnverifiedCigs, { CIGProfilePartial } from "../getUnverifiedCigs";

const useGetUnverifiedCigs = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<CIGProfilePartial[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const cigs = await getUnverifiedCigs();
      setSuccess(cigs);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetUnverifiedCigs;
